<div class="compliance-assessment-public">
	<div class="ca-public-wrap" *ngIf="!vm.loading && !vm.invalid && vm.role !== 'reviewer'">
		<div class="ca-owner-hero">
			<span class="ca-owner-avatar">{{ vm.ownerInitials() }}</span>
			<div style="min-width:0;">
				<div class="ca-eyebrow">{{ 'Compliance_Assessment.Action_Public_Signed_In_Task_Owner' | translateUnauthenticated }}</div>
				<h1 class="ca-title">{{ vm.ownerName() }}</h1>
				<p class="ca-small ca-muted" style="margin:3px 0 0;">{{ 'Compliance_Assessment.Action_Public_Owner_Intro' | translateUnauthenticated }}</p>
			</div>
		</div>
		<div class="ca-section-title">
			<h2>{{ 'Compliance_Assessment.Action_Public_Your_Action_Item' | translateUnauthenticated }}</h2>
			<span class="ca-chip">{{ vm.done ? 1 : 0 }} / 1 {{ 'Compliance_Assessment.Done' | translateUnauthenticated }}</span>
		</div>
		<div class="ca-track-card" [ngClass]="{'done': vm.done}">
			<div class="ca-track-head">
				<div class="ca-track-main">
					<div class="ca-track-title">{{ vm.action?.title }}</div>
					<div class="ca-track-meta">
						<span *ngIf="vm.action?.riskArea">{{ vm.action.riskArea }}</span>
						<span *ngIf="vm.action?.cutOffDate">{{ 'Compliance_Assessment.Due' | translateUnauthenticated }} {{ vm.action.cutOffDate | date:'dd MMM yyyy' }}</span>
					</div>
				</div>
					<div class="ca-track-status">
						<label class="ca-done-toggle">
							<input type="checkbox" [disabled]="vm.saving || vm.uploading" [ngModel]="vm.done" (ngModelChange)="vm.toggleDone($event)">
							{{ 'Compliance_Assessment.Mark_Done' | translateUnauthenticated }}
						</label>
					</div>
			</div>
			<p class="ca-small ca-muted" style="margin:10px 0 0;" *ngIf="vm.action?.description">{{ vm.action.description }}</p>
			<textarea class="ca-textarea" [(ngModel)]="vm.input" [placeholder]="'Compliance_Assessment.Progress_Note_Placeholder' | translateUnauthenticated"></textarea>
			<div class="ca-track-row">
				<label class="ca-doc-input">
					{{ 'Compliance_Assessment.Attach_Documents' | translateUnauthenticated }}
					<input type="file" [disabled]="vm.saving || vm.uploading" multiple (change)="vm.addDocuments($event)">
				</label>
				<button type="button" class="ca-btn ca-btn-ghost ca-btn-sm" [disabled]="vm.saving || vm.uploading" (click)="vm.saveNote()">{{ 'Compliance_Assessment.Save_Note' | translateUnauthenticated }}</button>
				<span class="ca-small ca-muted" role="status" *ngIf="vm.uploading">{{ 'Toolkit.Common.Loading' | translateUnauthenticated }}</span>
				<span class="ca-small ca-muted" *ngIf="vm.saved">{{ 'Compliance_Assessment.Saved' | translateUnauthenticated }}</span>
			</div>
			<div class="ca-track-row" *ngIf="vm.documentFiles?.length || vm.documents?.length">
				<span class="ca-doc-chip" *ngFor="let file of vm.documentFiles || []">
					<button type="button" class="ca-link-button" (click)="vm.downloadDocument(file)">{{ file.name }}</button>
					<button type="button" [disabled]="vm.saving || vm.uploading" (click)="vm.removeDocument(file)" [attr.aria-label]="'Compliance_Assessment.Remove_Document' | translateUnauthenticated">×</button>
				</span>
				<span class="ca-doc-chip" *ngFor="let documentName of vm.documents">
					{{ documentName }}
					<button type="button" [disabled]="vm.saving || vm.uploading" (click)="vm.removeDocument(documentName)" [attr.aria-label]="'Compliance_Assessment.Remove_Document' | translateUnauthenticated">×</button>
				</span>
			</div>
		</div>
		<div class="ca-toast" *ngIf="vm.toastKey">{{ vm.toastKey | translateUnauthenticated }}</div>
	</div>
	<div class="compliance-assessment-box ca-public-wrap" *ngIf="!vm.loading && !vm.invalid && vm.role === 'reviewer'">
		<h1 style="margin-top: 0;">{{ (vm.role === 'reviewer' ? 'Compliance_Assessment.Action_Public_Review_Title' : 'Compliance_Assessment.Action_Public_Complete_Title') | translateUnauthenticated }}</h1>
		<p><b>{{ vm.action?.title }}</b></p>
		<p>{{ vm.action?.description }}</p>
		<p *ngIf="vm.action?.riskArea">{{ 'Compliance_Assessment.Risk_Area' | translateUnauthenticated }}: {{ vm.action.riskArea }}</p>
		<textarea [(ngModel)]="vm.input" [placeholder]="(vm.role === 'reviewer' ? 'Compliance_Assessment.Action_Public_Review_Note' : 'Compliance_Assessment.Action_Public_Completion_Input') | translateUnauthenticated"></textarea>
		<button type="button" class="compliance-assessment-button" style="margin-top: 12px;" (click)="vm.submit()" [disabled]="vm.done">{{ (vm.role === 'reviewer' ? 'Compliance_Assessment.Action_Public_Accept_Review' : 'Compliance_Assessment.Action_Public_Submit_Assignment') | translateUnauthenticated }}</button>
		<p *ngIf="vm.done" style="margin-top: 12px;">{{ 'Compliance_Assessment.Action_Public_Submitted' | translateUnauthenticated }}</p>
	</div>
	<div class="compliance-assessment-box ca-public-wrap" *ngIf="!vm.loading && vm.invalid">
		<h1 style="margin-top: 0;">{{ 'Compliance_Assessment.Action_Public_Invalid_Link' | translateUnauthenticated }}</h1>
	</div>
</div>
